import React from "react";
import svg39 from "../../../assets/svg/svg39.svg";

import { Collapse } from 'antd';
import MpesaForm from "./MpesaForm";
import BankForm from "./BankForm";
const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;
const items = [
  {
    key: '1',
    label: 'Mpesa',
    children: <MpesaForm/>,
  },
  {
    key: '2',
    label: 'Bank',
    children:<BankForm/>,
  }, 
];
function WithdrawalOptions() {
    const onChange = key => {
    console.log(key);
  };
  return (
    <Collapse
      items={items}
      onChange={onChange}
      expandIconPosition="end"  
      accordion
      expandIcon={({ isActive }) => (
            <div className="flex items-center justify-center w-[2.5rem] h-[2.5rem] rounded-[6.25rem] bg-white">
          <img src={svg39} alt="svg39" />
        </div>
      )}
    /> 
  );
}

export default WithdrawalOptions;
